/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Open_DashboardInputs */

const en_auth_login_open_dashboard = /** @type {(inputs: Auth_Login_Open_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open dashboard`)
};

const pl_auth_login_open_dashboard = /** @type {(inputs: Auth_Login_Open_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz pulpit`)
};

/**
* | output |
* | --- |
* | "Open dashboard" |
*
* @param {Auth_Login_Open_DashboardInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_open_dashboard = /** @type {((inputs?: Auth_Login_Open_DashboardInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Open_DashboardInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_open_dashboard(inputs)
	return en_auth_login_open_dashboard(inputs)
});